<template>
    <div id="daily-brush">

        <div class="d-flex flex-column flex-lg-row justify-content-between my-5">
            <div class="d-flex flex-column w-lg-50 my-auto" v-if="task">
                <h3>DINȚIȘORII SĂNĂTOȘI ȘI FERICIȚI SE SPALĂ ZI DE ZI!</h3>
                <p class="pt-4">Cu toții știm ce bine se simt dințișorii când sunt veseli și sănătoși. Dar ca să îi
                    ținem așa, trebuie să ne ocupăm de ei în fiecare zi. Dacă te-ai spălat pe dinți astăzi, apasă
                    butonul. Bravo!</p>
                <h6 class="pt-2">
                    Misiuni îndeplinite: <span v-if="currentStreak" v-text="currentStreak.length"></span>
                </h6>
                <div>
                    <button class="px-sm-3 py-1 mt-3" @click="checkIn()" id="dailyCheckIn">
                        M-AM SPĂLAT PE DINȚI AZI
                    </button>
                    <div>
                        <span v-text="errorMessage"></span>
                    </div>
                </div>
            </div>
            <div>
                <img src="../../assets/imgs/profile/dintica.png" alt="" class="img-fluid dintica">
            </div>
        </div>

        <div class="d-flex flex-column justify-content-center align-items-center mb-5">
            <h4>
                Te-ai spălat azi pe dinți?
            </h4>
            <div class="d-flex flex-column flex-sm-row flex-wrap align-items-center justify-content-sm-between w-100 pt-3" v-if="missions">
                <div v-for="(mission, index) in missions" v-bind:key="index">
                    <div
                            class="d-flex flex-column checkin-day"
                            :class="mission.checked ? 'active' : ''">
                        <div v-if="mission.checked" class="mx-auto my-auto">
                            <img src="../../assets/imgs/profile/check.png" alt="" class="img-fluid">
                        </div>
                    </div>
                    <h6 class="text-center pt-3 days" v-text="mission.checkinDay !== '' ? mission.checkinDay : 'soon'"></h6>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    const axios = require('axios');

    import Swal from 'sweetalert2';

    const  Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000
    });

    export default {
        name: "DailyBrush",
        data() {
            return {
                baseUrl: null,
                terminalUID: null,
                accessToken: null,
                task: null,
                currentStreak: null,
                errorMessage: null,
                missions: [],
                headers: null,
                days: [
                    'Duminică',
                    'Luni',
                    'Marți',
                    'Miercuri',
                    'Joi',
                    'Vineri',
                    'Sâmbătă',
                ]
            }
        },
        mounted() {
            let self = this;
            this.baseUrl = this.$cookie.get('base-url');
            this.accessToken = this.$cookie.get('access-token');
            this.terminalUID = this.$cookie.get('terminal-uid');
            this.headers = {
                'terminal-uid': this.terminalUID,
                'Access-Control-Allow-Headers': 'Authorization',
                'Authorization': this.accessToken,
                'Content-Type': 'application/json',
            };
            setTimeout(function () {
                self.getTasksProgress();
            }, 300)
        },
        methods: {
            getTasksProgress() {
                let self = this;
                let today = new Date();
                let todayNr = today.getDay();
                const $ = window.$;

                const headers = this.headers;
                axios.defaults.headers.common['Authorization'] = this.accessToken;
                axios.defaults.headers.common['terminal-uid'] = this.terminalUID;

                axios.get(
                    this.baseUrl + 'api/tasks/progress',
                    {
                        headers
                    })
                    .then(function (response) {
                        self.task = response.data.result.user_tasks[0].task;
                        self.currentStreak = response.data.result.user_tasks[0].currentStreak;

                        for (let i = 0; i < self.task.checkins_to_complete; i++) {
                            self.missions.push({
                                id: i,
                                checked: '',
                                checkinDay: '',
                                checkinDayNr: ''
                            })
                        }

                        self.currentStreak.forEach((element, index) => {
                            self.missions[index].checked = true;
                            self.missions[index].checkinDay = self.days[new Date(element.created_at).getDay()];
                            self.missions[index].checkinDayNr = new Date(element.created_at).getDay();

                            let dailyDate = new Date(element.created_at);

                            if(today.getDate() === dailyDate.getDate() ) {
                               setTimeout(function () {
                                   document.getElementById('dailyCheckIn').setAttribute('disabled', 'disabled');
                                   $('#dailyCheckIn').addClass('disabled');
                               }, 100)
                            }
                        });

                        if( self.currentStreak.length > 0 ){
                            self.missions.forEach((element, index) => {
                                if (element.checkinDay === '') {
                                    element.checkinDayNr = (self.missions[index - 1].checkinDayNr + 1) % 7;
                                    element.checkinDay = self.days[element.checkinDayNr];
                                }
                            });
                        } else {
                            self.missions.forEach((element, index) => {
                                if(index === 0) {
                                    element.checkinDayNr = todayNr;
                                    element.checkinDay = self.days[element.checkinDayNr];
                                }

                                if (element.checkinDay === '') {
                                    element.checkinDayNr = (self.missions[index - 1].checkinDayNr + 1) % 7;
                                    element.checkinDay = self.days[element.checkinDayNr];
                                }
                            });
                        }


                    })
                    .catch(function (error) {
                        console.log('error', error);
                    });
            },

            checkIn() {
                this.baseUrl = this.$cookie.get('base-url');
                this.accessToken =  this.$cookie.get('access-token');
                let self = this;
                const headers = this.headers;
                axios.defaults.headers.common['Authorization'] = this.accessToken;
                axios.defaults.headers.common['terminal-uid'] = this.terminalUID;

                axios.post(
                    this.baseUrl + 'api/tasks/' + this.task.id + '/checkin',
                    {headers}
                )
                    .then(function (response) {
                        self.missions = [];
                        console.log('response checkin', response);

                        Toast.fire({
                            type: 'error',
                            title: 'Misiune salvata cu succes!',
                            animation: true,
                            customClass: {
                                popup: 'animated tada'
                            }
                        });

                        self.getTasksProgress();
                    })
                    .catch(function (error) {
                        console.log('error', error);

                        Toast.fire({
                            type: 'error',
                            title: 'A aparut o eroare.',
                            animation: true,
                            customClass: {
                                popup: 'animated tada'
                            }
                        });
                    });
            }
        }
    }
</script>

<style scoped>

</style>